import { Appt } from "./appt.model";
import { CLPUserPref } from "./clpUserPref.model";
import { Contact } from "./contact.model";
import { CustomActionDD, CustomActionScreen, CustomButton } from "./customAction.model";
import { eContactTxtMsgStatus, eLiveConnectItemObjectType, eLiveConnectItemStatus, eMobileBlockType, eMobileOptType, eSkypeSettings } from "./enum.model";
import { DropDownItem, IntDropDownItem, SimpleResponse } from "./genericResponse.model";
import { LiveConnectItem } from "./live-connect-item.model";
import { RptResponseTime, RptResponseTimeAll, TxtMsgIB, VoiceCallInbound } from "./report.model";
import { TxtMsgSettings } from "./txtMsg.model";
import { ClpCompany } from "./company.model";
import { SAMContactField } from "./sam-contact-field.model";
import { TxtMsgTemplate } from "./textMsgTemplate.model";
import { CLPUser, OfficeCodes, TeamCodes } from "./clpuser.model";
import { VoiceRecording } from "./voiceRecordings.models";
import { EmailSnippet, EmailTemplateResponse, MailMergeTemplate } from "./emailTemplate.model";
import { EngageImageDocument } from "./imageDocument.model";


export interface LiveConnectt {
    liveConnectID: number;
    clpCompanyID: number;
    clpUserID: number;
    teamCode: number;
    officeCode: number;
    liveConnectName: string;
    speakName: string;
    backColor: string;
    textColor: string;
    topNotes: string;
    announceScript: string;
    announceVRID: number;
    isActive: boolean;
    dtCreated: string;
    isSRSActive: boolean;
    srsCLPCompanyID: number;
    srsMode: number;
    isAlertsTab: boolean;
    alertItems: string;
    isIBSMSSendUserAlertText: boolean;
}

export interface LiveConnectAccount {
    companyName: string;
    clpCompanyID: number;
}

export interface LiveConnectResponse {
    liveConnectList: LiveConnectt[];
}

export interface LiveConnectCLPUser {
    liveConnectID: number;
    liveConnectCLPUserID: number;
    liveConnectName: string;
    accountName: string;
    count: number;
    status: number;
    isStatus: boolean;
    isMultiRing: boolean;
    isOverflow: boolean;
    isSRS: boolean;
    speakName: string;
    mobile: string;
    isDelete: boolean;
}

export interface LiveConnectContactDuplicate {
    liveConnectID: number;
    liveConnectCLPUserID: string;
    status: string;
    isMultiRing: string;
    isOverflow: string;
}

export interface InCallSummary {
    liveConnectCLPUserID: number;
    liveConnectItemID: number;
    repName: string;
    clpCompanyID: number;
    userCLPCompanyID: number;
    dtCreated: string;
    contactName: string;
    liveConnectName: string;
    voiceCallID: number;
    callDisplay: string;
}

export interface LiveConnectDashLoadResponse extends SimpleResponse {
    //badgeCount: number;
    pinnedNewCount: number;
    alertsNewCount: number;
    filterLiveConnect: string[];
    inCallSummaryList: InCallSummary[];
    liveConnectItemList: LiveConnectItem[];
    lcContactList: LiveConnectContact[];
    filterUser: IntDropDownItem[];
    lcClpuserDD: IntDropDownItem[];
}

export interface LiveConnectDashHeaderResponse extends SimpleResponse {
    clpCompanyID: number;
    liveConnectClpuserID: number;
    liveConnectHeader: LiveConnectHeader;
}


export interface LiveConnectContactResponse extends SimpleResponse {
    lcContactList: LiveConnectContact[];
}

export interface LiveConnectHeaderResponse extends SimpleResponse {
    liveConnectHeaderResponse: LiveConnectHeader;
}

export interface LiveConnectHeader {
    LinkLiveDash: boolean;
    LinkAlerts: boolean;
    LinkTextAlerts: string;
    LinkPinned: boolean;
    PinnedCount: string;
    LinkArchivedItems: boolean;
    LinkAnalytics: boolean;
    LinkDeals: boolean;
    LinkTextDeals: string;
    ButtonCheckInOut: boolean;
    ButtonTextCheckInOut: string;
    ButtonColorCheckInOut: string;
    ButtonNoRing: boolean;
    ButtonTextNoRing: string;
    ButtonColorNoRing: string;
    LableUserDisplay: string;
    LinkSetting: boolean;
    isMasterTimerActive: boolean;
    litCheckOutTimerDiag: string;
    isBtnNoActivity: boolean;
}

export interface LiveConnectDashLoadRequest {
    clpCompanyID: number;
    liveConnectClpuserID: number;
    isFilerVisible: boolean;
    strSearchItem: string;
    selectedLiveConnectName: string;
    selectedRating: string;
    eType: eLiveConnectItemObjectType;
    eStatus: eLiveConnectItemStatus;
    startDate: string;
    endDate: string;
    pinnedCLPUserID: number;
}

export interface CasResponse extends SimpleResponse {
    customActionScreen: CustomActionScreen;
    customButtons: CustomButton[];
}

export interface LiveConnectVCLoadResponse extends SimpleResponse {
    contactID: number;
    companyName: string;
    repName: string;
    clpUserID: number;
    CallSummary: string;
    CallNotes: string;
    strContactInfo: string;
    strAgreementProgressBar: string;
    duplicateDisplaySummary: string;
    isAutoProc: boolean;
    autoProc: string;
    isCustomAction: boolean;
    customActionScreen: CustomActionScreen;
    customButtons: CustomButton[];
    customActionDD: CustomActionDD[];
    lnkLaunchVIP: string;
    isVip: boolean;
    defaultSGVIPID: number;
    isSendSGVIP: boolean;
    eContactTxtStat: eContactTxtMsgStatus;
    eBType: eMobileBlockType;
    iD: number;
    archiveIDB: number;
    contact: Contact;
}

export interface LiveConnectContactLoadResponse extends SimpleResponse {
    companyName: string;
    repName: string;
    clpUserID: number;
    strContactInfo: string;
    strAgreementProgressBar: string;
    duplicateDisplaySummary: string;
    customActionScreen: CustomActionScreen;
    customButtons: CustomButton[];
    customActionDDList: CustomActionDD[];
    lnkLaunchVIP: string;
    defaultSGVIPID: number;
    isSendSGVIP: boolean;
    isVip: boolean;
    isShowBlock: boolean;
    isAgreementProgressBar: boolean;
    isCustomAction: boolean;
    eContactTxtStat: eContactTxtMsgStatus;
    txtMsgSettings: TxtMsgSettings;
    isPinned: boolean;
    samContactField: SAMContactField;
    clpCompany: ClpCompany;
    userlstViewable: number[];
    userlstEditable: number[];
    contact: ContactExt;
    eSkype: eSkypeSettings;
    isShareable: boolean;
    ipLink: string;
    cmCustomText1Title: string;
    cmCustomText2Title: string;
    cmCustomText3Title: string;
    customDate1: string;
    customDate2: string;
    customDate3: string;
    customDate1Title: string;
    customDate2Title: string;
    customDate3Title: string;
    customText1: string;
    customText2: string;
    customText3: string;
    manager: string;
    isSubscribe: boolean;
}

export interface LiveConncetApptLoadResponse extends SimpleResponse {
    appt: Appt;
    objContactInfo: Contact;
    strContactInfo: string;
    companyName: string;
    repName: string;
    apptSummary: string;
    strAgreementProgressBar: string;
    strAutoProc: string;
    isAutoProc: boolean;
    customActionButtons: CustomButton[];
    customActionDD: CustomActionDD[]
    isCustomAction: boolean;
    lnkLaunchVIP: string;
    isVip: boolean;
    isSendSGVIP: boolean;
    eContactTxtStat: eContactTxtMsgStatus;
    eBType: eMobileBlockType;
    defaultSGVIPID: number;
    customActionScreen: CustomActionScreen;
}

export interface LiveConnectTxtmsgIBLoadResponse extends SimpleResponse {
    eMType: eMobileOptType;
    isVip: boolean;
    lnkLaunchVIP: string;
    ddToChoice: IntDropDownItem[];
    ddMediaImges: ddMediaImages[];
    strContactGoogleDirectionURL: string;
    txtMsgIB: TxtMsgIB;
    txtMsgSettings: TxtMsgSettings;
    companyName: string;
    repName: string;
    ddFromNumber: IntDropDownItem[];
    txtMsgTemplates: TxtMsgTemplate[];
    isCustomAction: boolean;
    customActionScreen: CustomActionScreen;
    customButtons: CustomButton[];
    customActionDD: CustomActionDD[];
    gbcMediaDD: any[];
    strcontactInfo: string;
    duplicateDisplaySummary: string;
    ibMessage: string;
    lastOBMessage: string;
    strAgreementProgressBar: string;
    eContactTxtStat: eContactTxtMsgStatus;
    eBType: eMobileBlockType;
    rddTemplate: IntDropDownItem[];
    userPref: CLPUserPref;
    defaultSGVIPID: number;
    contact: Contact;
    id: number;
    clpUserId: number;
    archiveIDB: number
}

export interface ddMediaImages {
    documentId: number
    documentTitle: string
    imagePath: string
}

export interface ContactExt extends Contact {
    class1CodeTitle: string;
    class2CodeTitle: string;
    class3CodeTitle: string;
    class4CodeTitle: string;
    class5CodeTitle: string;
    class6CodeTitle: string;
    class7CodeTitle: string;
    class8CodeTitle: string;
}

export interface TxtMessage {
    liveConnectID: number;
    liveConnectClpUserID: number;
    clpUserID: number;
    clpCompanyID: number;
    txtMsgIBID: number;
    txtmsgid: number;
    selectedToChoice: string;
    selectedFromNumber: string;
    strMediaURL: string;
    txtMsg: string;
    contactID: number;
    pnlSpecific: boolean;
    dtSelected: string;
    aVObjectID: number;
    lcMoveToReview: boolean;
}

export interface LiveConnectMakeVCLoadResponse extends SimpleResponse {
    companyName: string;
    repName: string;
    clpUserID: number;
    strContactInfo: string;
    strAgreementProgressBar: string;
    duplicateDisplaySummary: string;
    customActionScreen: CustomActionScreen;
    customButtons: CustomButton[];
    customActionDDList: CustomActionDD[];
    lnkLaunchVIP: string;
    defaultSGVIPID: number;
    isSendSGVIP: boolean;
    isVip: boolean;
    isAgreementProgressBar: boolean;
    isCustomAction: boolean;
    clpCompany: ClpCompany;
    ddUserPhone: DropDownItem[];
    ddContactPhone: DropDownItem[];
}

export interface VoiceCallConnect {
    voiceCallID: number;
    contactID: number;
    clpUserID: number;
    liveConnectCLPUserID: number;
    liveConnectID: number;
    cLPCompanyID: number;
    saveNotes: boolean;
    callMessage: string;
    ddUserPhone: string;
    ddContactPhone: string;
    txtPreCall: string;
    ispanelSpecific: boolean;
    dtstartDay: string;
}

export interface ActivitySummaryRequest {
    clpCompanyID: number;
    teamCode: number;
    cLPUserID: number;
    liveConnectID: number;
    liveConnectCLPUserID: number;
    contactID: number;
    eType: number;
    startDate: string;
    endDate: string;
    isRaw: boolean;
    isSlurpy: boolean;
    isSRS: boolean;
    OfficeCode: number;
    weekEndFilter: number;
}

export interface ActivitySummaryResponse extends SimpleResponse {
    liveConnectCLPUserID: number;
    RepName: string;
    ddLiveConnect: IntDropDownItem[];
    ddRep: DdRep[];
    ddType: IntDropDownItem[];
    teamDD: TeamCodes[];
    officeDD: OfficeCodes[];
    clpUserDD: CLPUser[];
    filterTeamDisplay: string;
    filterTeamCode: number;
    liveConnectAccounts: LiveConnectAccount[];
}

export interface ActivityReport {
    liveConnectLogID: number;
    clpCompanyID: number;
    liveConnectID: number;
    lveConnectClpUserID: number;
    contactID: number;
    objectID: number;
    actionType: number;
    userFullName: string;
    dtCreated: string;
    isUseLC: number;
    contactName: string;
    liveConnectName: string;
    voiceCallDuration: number;
    teamDisplay: string;
    lUClpCompanyID: number;
    typeDisplay: string;
    voiceCallDisplay: string;
    voiceCallDurationInMin: string;
}

export interface LCConnectActivityRep {
    rep: string;
    textSent: number;
    callInboundAnswered: number;
    callInboundMissed: number;
    callOutboundInitiated: number;
    callOutboundScheduled: number;
    callSavedNotes: number;
    selfGuidedSlidecastSent: number;
    slidecastLaunched: number;
    agreementSent: number;
    agreementEdited: number;
    dynamicSchedulerAppointmentCreated: number;
    emailSent: number;
    total: number;
}

export interface ActivityReportResponse extends SimpleResponse {
    activityReportResponse: ActivityReport[];
    lcConnectActivityRep: LCConnectActivityRep[];
    lcCallsRep: CallsRep[];
}

export interface CallsRep {
    userFullName: string;
    duration: number;
    calls: number;
    total: number;
}

export interface DdRep {
    liveConnectClpUserID: number;
    userFullName: string;
    countDdRep: number;
}

export interface ResponseTimeSetup extends SimpleResponse {
    isShowTeam: boolean;
    isShowOffice: boolean;
}

export interface LCResponseTime extends SimpleResponse {
    rptResponseTime: RptResponseTime[];
    allUserResponseTime: RptResponseTimeAll[];
}

export interface LCVoiceCallResponse extends SimpleResponse {
    inboundHour: VoiceCallInbound[];
    inboundDayOfWeek: VoiceCallInbound[];
}

export interface CheckInStatusSetupResponse extends SimpleResponse {
    liveConnectCLPUserID: number;
    repName: string;
    filterTeamDisplay: string;
    filterTeamCode: number;
    ddLiveConnect: IntDropDownItem[];
    teamDD: TeamCodes[];
    officeDD: OfficeCodes[];
    clpUserDD: CLPUser[];
    liveConnectAccounts: LiveConnectAccount[];
}

export interface LCCheckedInRequest {
    clpCompanyID: number;
    teamCode: number;
    clpUserID: number;
    liveConnectID: number;
    liveConnectCLPUserID: number;
    contactID: number;
    eType: number;
    startDate: string;
    endDate: string;
    isRaw: boolean;
    isSlurpy: boolean;
    isSRS: boolean;
    isSRSManager: boolean;
    strIsSRS: string,
    OfficeCode: number;
    isShowSRSOnly: boolean;
}

export interface CheckedInStatusResponse extends SimpleResponse {
    quickStatusLists: QuickStatusList[];
}

export interface QuickStatusList {
    liveConnectCLPUserID: number;
    status: number;
    StatusSort: number;
    AccountName: string;
    LastFirst: string;
    dtLastAction: string | null;
    dtLastCheked: string | null;
    checkedCount: number;
    statusDisplay: string;
    lastCheckedAgo: string;
    lastActionAgo: string;
    minutesCheckedIn: number;
    minutesLastAction: number;
}

export interface LiveConnectCheckedInStatusLog {
    logID: number;
    liveConnectCLPUserID: number;
    status: number;
    dtCreated: string;
    method: number;
    userFullName: string;
    statusDisplay: string;
    methodDisplay: string;
}

export interface LogGetListByMonth {
    logID: number;
    liveConnectCLPUserID: number;
    Status: number;
    dtCreated: string;
    method: number;
    monthDay: number;
}

export interface CalendarCheckedStatus {
    userID: number;
    month: number;
    year: number;
    day: number;
    hours: number;
    hoursAndMins: string;
}

export interface CheckStatusResponse extends SimpleResponse {
    checkedInListResponse: CalendarCheckedStatus[];
    totalHours: string;
    checkedLogsList: LiveConnectCheckedInStatusLog[];
    summaryMonthDD: LogGetSummaryByMonth[];
}

export interface LiveConnectSettingResponse extends SimpleResponse {
    lblSRSStatusDisplay: string;
    lblStatusDisplay: string;
    officeCodes: OfficeCodes[];
    teamCodes: TeamCodes[];
    officeCodesSRS: OfficeCodes[];
    teamCodesSRS: TeamCodes[];
    voiceRecordDD: VoiceRecording[];
    LiveConnectResponse: LiveConnectt;
    lblisAlertsTab: string;
    lblAlertItems: string;
    lblisIBSMSSendUserAlertText: string;
    lblSRSAccountDisplay: string;
}

export interface LiveConnectDealsResponse extends SimpleResponse {
    litFranSummary: string;
}

export interface FranchiseSummary {
    franchise: string;
    location: string;
    deals: number;
    commission: number;
    entry: number;
}

export interface LogGetSummaryByMonth {
    refMonthYear: string;
    ref: string;
    date: string;
}


export interface LiveConnectCLPUserResponse extends SimpleResponse {
    liveConnectUsers: LiveConnectCLPUser[]
}

export interface LiveConnectAccountResponse {
    liveConnectAccountList: LiveConnectAccount[]
}

export interface EngageCTeamResponse extends SimpleResponse {
    socTeamsList: EngageCTeam[];
}

export interface GBC_UserListResponse extends SimpleResponse {
    gbc_UsersLists: GBC_UserList[];
}

export interface GBC_UserList {
    clpUserID: number;
    teamDisplay: string;
    userDisplay: string;
}

export interface EngageCTeam {
    teamCode: number;
    teamDisplay: string;
    speakName: string;
    blackColor: string;
    textColor: string;
}

export interface LiveConnectContact {
    contactID: number;
    contactFullName: string;
    userFullName: string;
    email: string;
    mobile: string;
    teamCode: number;
    liveConnectID: number;
    createCardLiveConnectId: number;
}

export interface ContactArchive {
    contactID: number;
    liveConnectID: number;
    clpUserId: number;
}
export interface LiveConnectContactObj {
    clpCompanyId: number;
    liveConnectId: number;
    clpUserId: number;
    name: string;
    mobile: string;
    email: string;
}

export interface AssginedUsers {
    liveConnectID: number;
    liveConnectCLPUserID: number;
    isMultiRing: boolean;
    status: boolean;
    isDelete: boolean;
    ClpCompanyID: number;
    isOverFlowRing: string;
    isSrs: string;
    eStatus: number;
    teamCode: number;
    officeCode: number;
}


export interface LiveConnectItemResponse extends SimpleResponse {
    iveConnectItem: LiveConnectItem;
}

export interface OpenAiResponse extends SimpleResponse {
    response1: string;
    response2: string;
    response3: string;
    cbAI1: boolean;
    cbAI2: boolean;
    cbAI3: boolean;
    pnlAIResponses: boolean;
    btnGenerateAIResponse: boolean;
}

export interface LiveConncetEmailLoadResponse extends SimpleResponse {
    companyName: string;
    repName: string;
    clpUserID: number;
    strContactInfo: string;
    strAgreementProgressBar: string;
    duplicateDisplaySummary: string;
    customActionScreen: CustomActionScreen;
    customButtons: CustomButton[];
    customActionDDList: CustomActionDD[];
    lnkLaunchVIP: string;
    defaultSGVIPID: number;
    isSendSGVIP: boolean;
    clpCompany: ClpCompany;
    emailTemplateResponseDD: EmailTemplateResponse;
    mailMergetemplateDD: MailMergeTemplate[];
    emailSnippetDD: EmailSnippet[];
    clpUsersDD: CLPUser[];
    fileSizeLimit: string;
    documentList: Document[];
    searchFiles: Document[];
    linkedFiled: any;
    ddImages: EngageImageDocument[];
    ddToChoice: boolean;
}

export interface EmailBox {
    emailBoxID: number;
    clpCompanyID: number;
    clpUserID: number;
    inboxAddress: string;
    appPassword: string;
    imapServer: string;
    imapPort: number;
    isAddLiveConnectCard: boolean;
    searchMethod: number;
    isAutoAIPopulate: boolean;
    customSearchID: number;
    processor: number;
    isMoveToHandledFolder: boolean;
    handledFolderName: string;
    toProcessFolderName: string;
    isMarkUnhandledAsRead: boolean;
    ageMinutesToProcess: number;
    status: number;
    dtLastRun: string;
}

export interface EmailBoxResponse extends SimpleResponse {
    emailBox: EmailBox;
}

export enum eEmailBoxStatus {
    None = 0,
    Active = 1,
    Disabled = 2
}

export enum eEmailBoxProcessor {
    Unknown = 0,
    Gmail = 1,
    Microsoft = 2,
    Apple = 3
}


export interface EmailBoxSuppressListResponse extends SimpleResponse {
    emailBoxSuppressList: EmailBoxSuppress[];
}

export interface EmailBoxSuppress {
    emailBoxID: number;
    emailBoxSuppressID: number;
    val: string;
    isDomain: boolean;
    dtCreated: string;
}
